import { Info } from '@mui/icons-material';
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import EnhancedTable from 'lib/designSystem/Table';
import { formatDate } from 'lib/functions/utils';
import React, { useState } from 'react';

import DocumentDialog from './components/DocumentDialog';

const useStyles = makeStyles(() =>
  createStyles({
    table: {
      width: '100%', // ensure the table fits its container
    },
    tableCell: {
      padding: '2px 6px !important',
      maxWidth: '200px',
      maxHeight: '6px',
      overflow: 'hidden', // Ensure the content doesn't overflow.
      whiteSpace: 'nowrap', // Ensure the text doesn't wrap to the next line.
    },
    tableContainer: {
      border: '1px solid #e0e0e0',
      borderRadius: '10px',
    },
    tableBody: {
      backgroundColor: '#ffffff',
    },
    selectFullWidth: {
      width: '100%',
    },
    selectSmall: {
      width: '200px', // or any other small width
    },
  }),
);

const ReportAccruingTable = (props: any) => {
  const { rows, headers, dailyLinesByDocumentId, startDate, endDate } = props;
  const classes = useStyles();
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [selectedRowLines, setSelectedRowLines] = useState<any>(null);

  const handleOpenDialog = (row: any) => {
    setSelectedRow(row);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
  };

  const handleClickRow = (id: any) => {
    const rowData = rows.find((r: any) => r.id === id);
    setSelectedRow(rowData);
    setSelectedRowLines(dailyLinesByDocumentId[id]);
    setOpenDialog(true);
  };

  return (
    <div style={{ paddingBottom: 100 }}>
      <EnhancedTable
        dataHeaders={headers}
        data={rows}
        finalSumRow
        rowsPerPageDefault={500}
        rowsPerPageOptions={[500, 1000]}
        handleClickRow={handleClickRow}
        exportToFile="xlsx"
        fileName={`reporte_ingresos_por_devengo_${formatDate(new Date(startDate))}_${formatDate(new Date(endDate))}.xlsx`}
      />
      {/* <TableContainer className={classes.tableContainer}>
        <Table className={classes.table}>
          <TableHead style={{ background: '#efefef' }}>
            {headers.map((header: any, headerIndex: any) => (
              <TableCell key={headerIndex}>{header}</TableCell>
            ))}
          </TableHead>
          <TableBody className={classes.tableBody}>
            {rows.map((row: any, rowIndex: any) => (
              <TableRow key={rowIndex}>
                {headers.map((header: any, headerIndex: any) => (
                  <TableCell key={headerIndex}>{row[header]}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer> */}
      {selectedRow && openDialog && (
        <DocumentDialog
          row={selectedRow}
          openDialog={openDialog}
          handleCloseDialog={handleCloseDialog}
          lines={selectedRowLines}
        />
      )}
    </div>
  );
};

export default ReportAccruingTable;
